import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container, Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import axios from 'axios';
import fmt from 'indian-number-format';
import Page from 'src/components/Page';
import Header from './Header';
import Overview from './Overview';
import LatestOrders from './LatestOrders';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));

function DashboardAnalytics() {
  const classes = useStyles();
  const [selectedState, setSelectedState] = useState('');
  const [selectedConstituency, setSelectedConstituency] = useState('');
  const [selectedPart, setSelectedPart] = useState('');
  const [epics, setEpics] = useState(null);
  const [sectionReport, setSectionReport] = useState(null);
  const [startDate, setStartDate] = useState(moment().subtract(7, 'days'));
  const [endDate, setEndDate] = useState(moment());

  useEffect(() => {
    getPartOverview();
  }, [selectedState, selectedConstituency, selectedPart, startDate, endDate]);

  const getPartOverview = async () => {
    let options = {
      'headers': {
        'x-zippr-api-key': '401c6d83-f89d-4a90-a387-c94c229abb2c'
      }
    };

    if(!selectedState || !selectedConstituency){
      let state = localStorage.getItem('state');
      let constituency = localStorage.getItem('constituency');
      setSelectedState(state);
      setSelectedConstituency(constituency);
    }
    let constituencyParam = JSON.parse(localStorage.getItem('ac_map'))[selectedConstituency];
    let stateParam = JSON.parse(localStorage.getItem('state_map'))[selectedState];
    let response = await axios.get(`https://dev.zip.pr/eci/part?state=${stateParam}&assembly_constituency=${constituencyParam}&part=${selectedPart}&start_date=${startDate.format('DD-MM-YYYY')}&end_date=${endDate.format('DD-MM-YYYY')}`, options);
    if(!response.data.ok) return
    setEpics(fmt.format(response.data.response.snapshot.totalEpics))
    setSectionReport(response.data.response.sectionWiseCounts);
  }

  return (
    <Page
      className={classes.root}
      title="Analytics Dashboard"
    >
      <Container maxWidth={false}>
        <Header state={selectedState} stateHandle={setSelectedState} constituency={selectedConstituency} constituencyHandle={setSelectedConstituency} part={selectedPart} partHandle={setSelectedPart} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate}/>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
          >
            <Overview epics={epics} />
          </Grid>
          <Typography
            component="h2"
            gutterBottom
            variant="h3"
            style={{textTransform: 'none', marginLeft: '9px'}}
          >
            Part Level Report
          </Typography>
          <Grid
            item
            xs={12}
          >
            <LatestOrders report={sectionReport} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}

export default DashboardAnalytics;
